/** @jsxImportSource @emotion/react */

import { memo, ReactNode } from "react";

import { SerializedStyles } from "@emotion/react";
import { InputLabelProps, InputLabel, Tooltip } from "@material-ui/core";

import { Icon } from "..";

import { label, icon, requiredStyles } from "./styles";

interface Props extends InputLabelProps {
  text: string;
  tip?: string | ReactNode;
  labelStyles?: SerializedStyles;
  required?: boolean;
}

const Label = ({ text, tip, labelStyles, required = false }: Props): JSX.Element => (
  <InputLabel css={[label, labelStyles]}>
    {required && <span css={requiredStyles}>*</span>}
    {text}
    {tip && (
      <Tooltip title={tip} placement="right" interactive>
        <div css={icon}>
          <Icon name="exclamation-mark" fontSize="inherit" color="primary" />
        </div>
      </Tooltip>
    )}
  </InputLabel>
);

export default memo(Label);
